import { render, staticRenderFns } from "./returnHead.vue?vue&type=template&id=06364c7b&"
import script from "./returnHead.vue?vue&type=script&lang=js&"
export * from "./returnHead.vue?vue&type=script&lang=js&"
import style0 from "./returnHead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports